import { Box, CardActionArea, Stack } from '@mui/material'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import { Link } from 'react-router-dom'

interface Props {
  to?: string
  title: string
  place: string
  src: string
  time: string
  summary: string
  released: boolean
}
export default function EventCard({
  to = '#',
  place,
  time,
  src,
  title,
  summary,
  released,
}: Props) {
  return (
    <Card elevation={2}>
      <Link to={to}>
        <CardActionArea>
          <CardContent>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={1}
            >
              <Box
                sx={{
                  width: '60%',
                }}
              >
                <Typography
                  gutterBottom
                  color={released ? 'primary' : 'error'}
                  variant="body1"
                  component="p"
                  sx={{
                    width: '100%',
                    fontWeight: 'bold',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {released ? '公開中' : '非公開'}
                </Typography>
                <Typography
                  gutterBottom
                  variant="body1"
                  component="h4"
                  sx={{
                    width: '100%',
                    fontWeight: 'bold',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {title}
                </Typography>
                <Typography
                  variant="body2"
                  component="h5"
                  mb={1}
                  sx={{
                    width: '100%',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {place}
                </Typography>
                <Typography variant="body2" component="p" mb={1}>
                  {time}
                </Typography>
                <Typography
                  variant="body2"
                  component="p"
                  sx={{
                    height: 40,
                    display: '-webkit-box',
                    WebkitLineClamp: '2',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                  }}
                >
                  {summary}
                </Typography>
              </Box>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                width={'40%'}
                sx={{
                  width: {
                    xs: '160px',
                    md: '200px',
                  },
                  height: {
                    xs: '120px',
                    md: '150px',
                  },
                }}
              >
                <img
                  src={src}
                  alt={title}
                  loading="lazy"
                  crossOrigin="anonymous"
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                  }}
                />
              </Box>
            </Stack>
          </CardContent>
        </CardActionArea>
      </Link>
    </Card>
  )
}
